export const iconsSmallWidth: string[] = [
    'splashmacs',
    'larkwood',
    'alsicare',
    'asquith-fox',
    'alpha-solway',
    'alsicare',
    'alsico',
    'american-apparel',
    'ansell',
    'b-brand',
    'babybugz',
    'bagbase',
    'bates',
    'beechfield',
    'bella-canvas',
    'berghaus',
    'beeswift',
    'build-your-brand',
    'caterpillar',
    'click',
    'columbia',
    'dewalt',
    'flexfit-by-yupoong',
    'front-row',
    'gamegear',
    'glenmuir',
    'goliath',
    'jerzees-schoolgear',
    'jerzees',
    'kustom-kit',
    'la-beeby',
    'patagonia',
    'portwest',
    'pulsar',
    'workwear-express',
    'westford-mill',
    'stormtech',
    'stanley-stella',
    'skechers',
    'gill',
];
